import React, { useState, useRef, useEffect, useCallback } from 'react';
import './App.css';

const App = () => {
  const [query, setQuery] = useState("");
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [offset, setOffset] = useState(0);
  const [vestiaireData, setVestiaireData] = useState([]);





  const mapItems = (items, website) => {
    return items.map((item) => {
      let mappedItem = {
        designer: '',
        name: '',
        price: '',
        size: '',
        photo: '',
        link: '',
        website: website,
        timestamp: ''
      };

      if (website === 'vestiaire') {
        mappedItem.designer = item.brand.name;
        mappedItem.name = item.name;
        mappedItem.price = item.price.cents / 100 + ' ' + item.price.currency;
        mappedItem.size = item.size ? item.size.label : '';

        mappedItem.photo = getImageUrl(item.pictures[0]);
        mappedItem.link = getRedirectUrl(item.link);
        // timestamp = item.created
      } else if (website === 'mercari') {
        mappedItem.name = item.title;
        mappedItem.price = item.price;
        mappedItem.size = item.itemSize.name;
        mappedItem.photo = item.thumbnails[0];
        // timestamp = created_at_i
      } else if (website === 'grailed') {
        mappedItem.name = item.title;
        mappedItem.price = item.price;
        mappedItem.size = item.size;
        mappedItem.photo = item.cover_photo.url;
        // timestamp = item.created_at
      }

      return mappedItem;
    });
  };

  const fetchVestiaireData = useCallback(async () => {
    if (!fetched) {
      try {
        const response = await fetch(
          "https://search.vestiairecollective.com/v1/product/search",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json, text/plain, */*",
              Referer: "https://www.vestiairecollective.com/",
              "x-usertoken": "9029143",
              "sec-ch-ua-platform": '"Windows"',
            },
            body: JSON.stringify({
              pagination: {
                offset: offset,
                limit: 48,
              },
              fields: [
                "name",
                "description",
                "brand",
                "model",
                "country",
                "price",
                "discount",
                "link",
                "sold",
                "likes",
                "editorPicks",
                "shouldBeGone",
                "seller",
                "directShipping",
                "local",
                "pictures",
                "colors",
                "size",
                "stock",
                "universeId",
              ],
              facets: {
                fields: [
                  "brand",
                  "universe",
                  "country",
                  "stock",
                  "color",
                  "categoryLvl0",
                  "priceRange",
                  "price",
                  "condition",
                  "region",
                  "editorPicks",
                  "watchMechanism",
                  "discount",
                  "sold",
                  "directShippingEligible",
                  "directShippingCountries",
                  "localCountries",
                  "sellerBadge",
                  "isOfficialStore",
                  "materialLvl0",
                  "size0",
                  "size1",
                  "size2",
                  "size3",
                  "size4",
                  "size5",
                  "size6",
                  "size7",
                  "size8",
                  "size9",
                  "size10",
                  "size11",
                  "size12",
                  "size13",
                  "size14",
                  "size15",
                  "size16",
                  "size17",
                  "size18",
                  "size19",
                  "size20",
                  "size21",
                  "size22",
                  "size23",
                  "dealEligible",
                ],
                stats: ["price"],
              },
              q: query,
              sortBy: "recency",
              filters: {},
              locale: {
                country: "FI",
                currency: "EUR",
                language: "en",
                sizeType: "US",
              },
              mySizes: null,
            }),
          }
        );

        const jsonData = await response.json();
        const data = mapItems(jsonData.items, "vestiaire");

        setVestiaireData((vestiaireData) => [...vestiaireData, ...data]);
        setProducts((prevProducts) => [...prevProducts, ...data]); // added this line
      } catch (error) {
        console.error("Error fetching products:", error);
        setOffset((prevOffset) => prevOffset + 48);
      }
    }
  }, [query, offset, fetched, mapItems]);

  useEffect(() => {
    const fetchData = async () => {
      if (!fetched) {
        setLoading(true);
        await fetchVestiaireData();
        setLoading(false);
        setFetched(true);
      }
    };
    fetchData();
  }, [fetched, fetchVestiaireData]);


  const handleSubmit = (event) => {
    event.preventDefault();
    if (window.innerWidth < 600) {
      event.target.elements[0].blur();
    }
    const shadows = document.querySelectorAll('.shadow');
    shadows.forEach((shadow) => {
      // Get the current animation name
      const currentAnimation = shadow.style.animationName;
      // Determine the reverse animation name
      const reverseAnimation = currentAnimation === 'shrinkAndMoveRight' ? 'growAndMoveRight' : 'growAndMoveLeft';

      // Reset the animation
      shadow.style.animation = 'none';
      // Cause a reflow, flushing the CSS changes
      void shadow.offsetWidth;
      // Re-add the animation
      shadow.style.animation = `${reverseAnimation} 1s ease-in-out forwards`;


      // Listen for when the animation ends
      shadow.addEventListener('animationend', function handler() {
        setProducts([]); // clear the old search results
        setOffset(0); // reset the offset
        setFetched(false); // trigger new fetch


        // Remove this event listener so it only gets triggered once
        shadow.removeEventListener('animationend', handler);
        // Switch the animation to its opposite
        const newAnimation = reverseAnimation === 'growAndMoveLeft' ? 'shrinkAndMoveRight' : 'shrinkAndMoveLeft';
        // Reset the animation
        shadow.style.animation = 'none';
        // Cause a reflow, flushing the CSS changes
        void shadow.offsetWidth;
        // Re-add the new animation
        shadow.style.animation = `${newAnimation} 2s ease-in-out forwards`;
      });
    });
  };

  useEffect(() => {
    if (offset === 0) {
      fetchVestiaireData(offset);
    }
  }, [offset, fetchVestiaireData]);


  const handleScroll = () => {
    if (
      document.documentElement.scrollTop + window.innerHeight >=
      document.documentElement.offsetHeight && offset !== 0 // Add this check here
    ) {
      setOffset((prevOffset) => {
        const newOffset = prevOffset + 48;
        fetchVestiaireData(newOffset);
        return newOffset;
      });
    }
  };


  // Reset the offset when the query changes
  useEffect(() => {
    setOffset(0);
  }, [query]);


  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const getImageUrl = (imagePath) => {
    return `https://images.vestiairecollective.com/cdn-cgi/image/w=500,f=auto,${imagePath}&`;
  };

  const getRedirectUrl = (productLink) => {
    return `https://www.vestiairecollective.com${productLink}`;
  };

  const divs = [];

  // if screen is small, only show 5 shadows
  if (window.innerWidth < 600) {
    for (let i = 0; i < 20; i++) {
      divs.push(<div className="shadow sh1"></div>);
    }
  } else {
    for (let i = 0; i < 20; i++) {
      divs.push(<div className="shadow sh1"></div>);
    }
  }


  useEffect(() => {
    // Delay the execution until the rendering is complete
    setTimeout(() => {
      // select all .shadow elements
      var shadows = document.querySelectorAll('.shadow');

      shadows.forEach(function (shadow) {
        // generate a random position for each shadow element
        const randomTop = Math.random() * window.innerHeight - (shadow.offsetHeight / 2);
        const randomLeft = Math.random() * window.innerWidth - (shadow.offsetWidth / 2);
        // generate a random z-index
        const randomZIndex = Math.floor(Math.random() * 10 + 5);  // change 1000 to whatever max z-index you want

        // assign the random position and z-index to the shadow element
        shadow.style.position = 'fixed';
        shadow.style.top = `${randomTop}px`;
        shadow.style.left = `${randomLeft}px`;
        shadow.style.zIndex = randomZIndex;
      });
    }, 0);  // Delay of 0
  }, []); // empty array means this effect runs once on mount


  useEffect(() => {
    requestAnimationFrame(() => {
      const shadows = document.querySelectorAll('.shadow');
      const animations = ['shrinkAndMoveRight', 'shrinkAndMoveLeft'];
      shadows.forEach((shadow) => {
        const animation = animations[Math.floor(Math.random() * animations.length)];
        shadow.style.animation = `${animation} 2s ease-in-out forwards`;
      });
    });
  }, []);



  return (
    <div>
      <div class="wshadow">
        {divs}
      </div>


      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <br />
        <form onSubmit={handleSubmit} style={{
          marginBottom: '1rem', width: '100%'
        }}>
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            style={{
              border: 'none',
              outline: 'none',
              fontSize: `${window.innerWidth / 16}px`,
              ...(window.innerWidth < 600 && {
                fontSize: `${window.innerWidth / 14}px`,
              }),
            }}
            placeholder="search for something"
          />
        </form>
        <hr style={{ marginBottom: '1rem' }} />
      </div>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className="product-list">
          {products.map((product) => (
            <div className="product-card" key={product.id}>
              <a href={product.link} target="_blank" rel="noopener noreferrer">
                <img src={product.photo} alt={product.name} />
              </a>
              <div className='info'>
                <p className='designer' style={{ fontStyle: 'italic' }}>{product.designer}</p>
                <p className="size">{product.size}</p>
                <p className="price">{product.price}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default App;
